import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'
import ArrowButton from '~/checklist/components/ArrowButton'

interface Props {
  curriculumName: string
  curriculumCountryCode: string
  hint: string
  isExpanded: boolean
  isLight?: boolean
  onToggle: () => void
}

export default function CurriculumGroupItem({
  curriculumName,
  curriculumCountryCode,
  hint,
  isExpanded,
  isLight,
  onToggle,
}: Props): React.ReactElement {
  const { t } = useTranslation('generics')
  return (
    <button
      aria-expanded={isExpanded}
      className={`w-full flex flex-col items-start px-3.5 py-3 duration-300 ${
        isLight ? 'hover:bg-gray-light' : 'hover:bg-orange-faint'
      }`}
      onClick={onToggle}
      type="button"
    >
      <div className="w-full flex items-center justify-between">
        <span className="flex items-center space-x-2.5">
          <SVGImage
            alt={t('countryCode')}
            className="w-6"
            imageClassName="h-6 rounded-0.5"
            srcKey={`country-flags-rect/${curriculumCountryCode.toUpperCase()}.svg`}
          />
          <span className={`text-xs ${isLight ? 'text-gray-davy' : 'text-white-strong'}`}>{curriculumName}</span>
        </span>
        <ArrowButton color={isLight ? 'text-gray-davy' : 'text-white'} expanded={isExpanded} size={12} />
      </div>
      <span className={`text-3 ${isLight ? 'text-gray-placeholder' : 'text-white-half'}`}>{hint}</span>
    </button>
  )
}
